import React from "react";
import { GeofenceDirection, GeofenceNotificationLogDto } from "@/openapi";
import { NotificationTitle } from "./common";
import { useTranslation } from "react-i18next";

interface Props {
  notification: GeofenceNotificationLogDto;
}

export const Geofence: React.FC<Props> = ({ notification }) => {
  const { t } = useTranslation("notifications");
  return (
    <NotificationTitle>
      <b>{notification.notificationObjectMetadata.props.childName}</b>{" "}
      {notification.notificationObjectMetadata.props.direction === GeofenceDirection.Enter ? t("arrivedAt") : t("left")}{" "}
      <b>{notification.notificationObjectMetadata.props.savedLocationName}</b>
    </NotificationTitle>
  );
};
